import { getToken } from '@bettercomp/ams-spa-auth';
import { client } from 'connectors/ams/client.gen';
import { fetchWithRenewal } from 'service/amsFetch';

/**
 * Wiring for the generated AMS public connector. Import SDK functions from
 * this module, never from `connectors/ams` directly — the raw client has no
 * base URL, bearer, or renew-on-401 fetch until this module configures them.
 *
 * The AMS public API is same-origin behind the app's CloudFront `/ams/*`
 * behavior. There is deliberately no 401→logout interceptor here: the
 * unauthenticated config fetch must never trigger a logout, and authenticated
 * calls get renew-then-retry from fetchWithRenewal with terminal outcomes
 * flowing to the auth gate through the session itself.
 */
client.setConfig({
  baseUrl: '/ams',
  auth: () => getToken() ?? undefined,
  fetch: fetchWithRenewal,
});

// ===== REMOVE IN S11 =====
export const DEV_GRANTS_STORAGE_KEY = 'X-AMS-Dev-Grants';
const DEV_HEADER_NAMES = ['X-AMS-Dev-Account-Code', DEV_GRANTS_STORAGE_KEY] as const;

if (process.env.NODE_ENV === 'development') {
  client.interceptors.request.use((request) => {
    for (const headerName of DEV_HEADER_NAMES) {
      const value = localStorage.getItem(headerName);
      if (value) {
        request.headers.set(headerName, value);
      }
    }
    return request;
  });
}
// ===== REMOVE IN S11 =====

export * from 'connectors/ams/sdk.gen';
